import { createClient, type SupabaseClient } from '@supabase/supabase-js'

let client: SupabaseClient | null = null

export function isSupabaseConfigured(): boolean {
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined
  return Boolean(url && key)
}

/**
 * Lazily create the Supabase browser client. The publishable key (sb_publishable_...)
 * is safe to expose; RLS enforces access and the server derives actor identity from
 * the validated JWT (never a browser-supplied owner_id). PKCE flow per plan section 5.
 * The secret/service key is NEVER used here — it stays server-side in Edge Functions.
 */
export function getSupabase(): SupabaseClient {
  if (client) return client
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined
  if (!url || !key) {
    throw new Error(
      'Supabase is not configured. Copy .env.example to .env and set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY.',
    )
  }
  client = createClient(url, key, {
    auth: { persistSession: true, autoRefreshToken: true, flowType: 'pkce' },
  })
  return client
}
